import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import includes from 'lodash/includes';
import get from 'lodash/get';
import MetaTags from '~/components/MetaTags/MetaTags';
import { initStore } from '~/state/store';
import { operations as teamOperations } from '~/state/team';
import withState from '~/hocs/withState';
import logEvent from '~/util/analytics';

import Layout from '~/components/Layout/Layout';
import ExtraInfoCard from '~/components/ExtraInfoCard/ExtraInfoCard';
import TeamBanner from '~/components/TeamBanner/TeamBanner';

import css from '~/pages/team.scss';

const getTeamIdFromState = state => get(state, 'teamData.data.id', '');

class TeamInfo extends React.Component {
  static async getInitialProps(props) {
    const teamId = parseInt(props.query.teamId, 10);
    if (props.leagueSlug && teamId !== getTeamIdFromState(props.store.getState())) {
      const team = await props.store.dispatch(
        teamOperations.setTeam(props.leagueSlug, props.query.teamId)
      );

      if (!team || includes(team.api_uri, '/error/events')) {
        props.res.statusCode = 404; // eslint-disable-line no-param-reassign
      }

      return {
        leagueSlug: props.query.leagueSlug,
      };
    }
    return {};
  }

  componentDidMount() {
    logEvent('page_view', {
      league: this.props.leagueSlug,
      page_type: 'team_info',
      team_id: this.props.team.id,
    });
  }

  render() {
    const { team } = this.props;

    return (
      <Layout>
        <Head>
          <style dangerouslySetInnerHTML={{ __html: css.stylesheet }} />
        </Head>
        <MetaTags content={team} type="team" />
        <TeamBanner team={team} currentSection="info" />
        {team.team_extra_info &&
          team.team_extra_info.length > 0 && (
            <div className={css.extraInfoCard}>
              <ExtraInfoCard extraInfo={team.team_extra_info} />
            </div>
          )}
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  team: state.teamData.data,
});

TeamInfo.propTypes = {
  leagueSlug: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
};

TeamInfo.displayName = 'TeamInfoPage';

export default withState({ createStore: initStore, mapStateToProps })(TeamInfo);
